export const ADD_BOX_SHADOW_BASKET_ACTION = 'ADD_BOX_SHADOW_BASKET_ACTION';
export const REMOVE_BOX_SHADOW_BASKET_ACTION = 'REMOVE_BOX_SHADOW_BASKET_ACTION';
export const REMOVE_ALL_BOX_SHADOW_BASKET_ACTION = 'REMOVE_ALL_BOX_SHADOW_BASKET_ACTION';
export const CLEAR_SHADOW_BASKET_ACTION = 'CLEAR_SHADOW_BASKET_ACTION';
export const CONFIRM_SHADOW_BASKET_ACTION = 'CONFIRM_SHADOW_BASKET_ACTION';
export const REPLACE_SUBSCRIPTION_PRODUCT = 'REPLACE_SUBSCRIPTION_PRODUCT';
